export default "__VITE_ASSET__NBOQA9gI__"